/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleGradeResult } from './moduleGradeResult';

export type GenericApiResponseModuleGradeResultData = ModuleGradeResult | null;
